/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：667
 */

module.exports = "https://creation.codemao.cn/coconut/web/1.22.0-0/" + "static/media/pedometer.08b217ab.svg"
